<script setup lang="ts">
import { MlSkeletonTable } from 'design.zorgdomein';
import { ref } from 'vue';

const props = withDefaults(
    defineProps<{
        delay?: number;
    }>(),
    {
        delay: 300
    }
);
const visible = ref(false);

// Wait {this.delay}ms before making the loading graphic visible.
// If whatever other async operation completes within that timeframe,
// then whichever parent component invoked the loading component will
// presumably re-render without the loading component.
// This helps prevent the loading graphic from too briefly "flashing" on the screen
// causing an undesirable flicker for users.
setTimeout(() => {
    visible.value = true;
}, props.delay);
</script>

<template>
    <div
        v-if="visible"
        class="container"
    >
        <div role="progressbar">
            <MlSkeletonTable />
        </div>
    </div>
</template>
